<div class="title">
  <h2 mat-dialog-title>Alterar foto</h2>
</div>
<mat-dialog-content>
  <div class="select-avatar">
    <label id="example-radio-group-label">Avatar:</label>
    <br />
    <input #file type="file" (change)="fileChangeEvent($event)" />
    <image-cropper
      *ngIf="imageChangedEvent"
      class="image-cropper"
      [imageChangedEvent]="imageChangedEvent"
      format="png"
      width="200px"
      height="200px"
      roundCropper="true"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded()"
      (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"
    ></image-cropper>
    <img
      *ngIf="imageChangedEvent"
      class="cropped-image"
      [src]="croppedImage"
      width="200px"
      height="200px"
    />
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    *ngIf="croppedImage"
    (click)="sendFile()"
    class="btn-primary"
    mat-raised-button
    color="primary"
  >
    Salvar
  </button>
</mat-dialog-actions>
